import { apiFetch } from "../../lib/api";
import { type StationOut } from "../stations/api";

export async function listUnverifiedStations(): Promise<StationOut[]> {
  return apiFetch<StationOut[]>("/admin/verification-queue", { auth: true });
}

type ReplaceTagsResponse = {
  station_id: string;
  tags: string[];
};

export async function replaceStationTags(
  stationId: string,
  tags: string[],
): Promise<ReplaceTagsResponse> {
  return apiFetch<ReplaceTagsResponse>(`/admin/stations/${stationId}/tags`, {
    method: "PUT",
    body: { tags },
    auth: true,
  });
}

export async function setStationVerified(
  stationId: string,
  verified: boolean,
): Promise<void> {
  await apiFetch<void>(`/admin/stations/${stationId}/verified`, {
    method: "PUT",
    body: { verified },
    auth: true,
  });
}
